module.exports = __webpack_public_path__ + "img/barracuda.b17f4e64.svg";